import { withServerSideTranslations } from '@zep/next/server';
import { TutorialPageView } from '../../../views';
const TutorialPage = () => {
  return <TutorialPageView data-sentry-element="TutorialPageView" data-sentry-component="TutorialPage" data-sentry-source-file="index.tsx" />;
};
export default TutorialPage;
export const getStaticProps = withServerSideTranslations(['common', 'home']);